export default "__VITE_ASSET__BKlXKyQD__"